export const generalInformationConstants = {
    GENERAL_INFORMATION_PENDING  : 'GENERAL_INFORMATION_PENDING',
    GENERAL_INFORMATION_FULFILLED: 'GENERAL_INFORMATION_FULFILLED',
    GENERAL_INFORMATION_REJECTED : 'GENERAL_INFORMATION_REJECTED',

    UPDATE_GENERAL_INFORMATION_PENDING  : 'UPDATE_GENERAL_INFORMATION_PENDING',
    UPDATE_GENERAL_INFORMATION_FULFILLED: 'UPDATE_GENERAL_INFORMATION_FULFILLED',
    UPDATE_GENERAL_INFORMATION_REJECTED : 'UPDATE_GENERAL_INFORMATION_REJECTED',
};